import { Injectable } from '@angular/core';
import { ApiService } from '../../api/api.service';

import { apiUrls } from '../../../config/api/api-urls.config';
import { ApplicationResultsResponse } from '../../../models/applications/responses/api-applications-results-response.model';

@Injectable({
  providedIn: 'root'
})
export class ApiApplicationsService {

  constructor(private apiService: ApiService) { }

  getApplications(): Promise<ApplicationResultsResponse> {
    return new Promise<ApplicationResultsResponse>((resolve, reject) => {
      this.apiService.launchAdminApiRequestGet(apiUrls.applicationsGetApplicationsUrl, ApplicationResultsResponse).then(
        (data: ApplicationResultsResponse) => { resolve(data); }, error => { reject(error); });
    });
  }

  addApplication(name: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.apiService.launchAdminApiRequestPost(apiUrls.applicationsAddApplicationUrl, { name }).then(
        () => { resolve(); }, error => { reject(error); });
    });
  }

  editApplication(id: number, name: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.apiService.launchAdminApiRequestPost(apiUrls.applicationsEditApplicationUrl, { id, name }).then(
        () => { resolve(); }, error => { reject(error); });
    });
  }

  deleteApplication(id: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.apiService.launchAdminApiRequestPost(apiUrls.applicationsDeleteApplicationUrl, { id }).then(
        () => { resolve(); }, error => { reject(error); });
    });
  }
}
